export const FINANCING_PARTNERS = ['METYCLE', 'CALF', 'SCCF', 'Rivonia', 'YONGGANG'] as const;

export type FinancingPartner = (typeof FINANCING_PARTNERS)[number];

export function isFinancingPartner(value: string): value is FinancingPartner {
  return (FINANCING_PARTNERS as readonly string[]).includes(value);
}
